import { DragEvent, RefObject } from "react";

export function getVerticalDragDirection(
  e: DragEvent<Element>,
  dragRef: RefObject<HTMLElement>
): "top" | "bottom" {
  const dragEventY = e.pageY;

  let sideY: "top" | "bottom" = "top";
  /**
   * Null check the ref for tests
   */
  if (dragRef.current) {
    const { bottom, top } = dragRef.current.getBoundingClientRect();
    sideY = Math.abs(top - dragEventY) < Math.abs(bottom - dragEventY) ? "top" : "bottom";
  }

  return sideY;
}

export function getHorizontalDragDirection(
  e: DragEvent<Element>,
  dragRef: RefObject<HTMLElement>
): "left" | "right" {
  const dragEventX = e.pageX;

  let sideX: "left" | "right" = "left";

  /**
   * Null check the ref for tests
   */
  if (dragRef.current) {
    const { left, right } = dragRef.current.getBoundingClientRect();
    sideX = Math.abs(left - dragEventX) < Math.abs(right - dragEventX) ? "left" : "right";
  }

  return sideX;
}
